<template>
  <div class="booking-list">

    <div class="booking-division" />
    <div class="booking-list-main">
      <!-- <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      > -->
      <div
        class="booking-list-item"
        v-for="item in orderList"
        :key="item.id"
      >
        <div class="booking-list-item-option">
          <div>
            录入时间：{{ item.create_time }}
          </div>
          <div>
          </div>
        </div>
        <div class="booking-list-item-option">
          <div>
            {{ item.user_name }}
          </div>
          <div>
            {{ item.level }}
          </div>
        </div>
        <div class="booking-list-item-option">
          <div>
            支付方式：{{ item.pay_type_name }}
          </div>
          <div>
          </div>
        </div>
        <div class="booking-list-item-option">
          <div>
            实付金额：{{ item.pay_amount }}
          </div>
          <div>
          </div>
        </div>
        <div class="booking-list-item-option">
          <div>
            财务核对状态：{{ item.check_status_name }}
          </div>
          <div>
          </div>
        </div>
        <div class="booking-list-item-option">
          <div>
            产品类型：{{ item.product_type_name }}
          </div>
          <div>
          </div>
        </div>

        <div class="booking-list-item-option">
          <div>
            备注：{{ item.remark }}
          </div>
          <div>

          </div>
        </div>
        <div class="booking-list-item-option">
          <div>
            付款凭证：
            <div
              class="booking-list-item-img-item"
              v-if="item.doc_data.doc_link"
            >
              <el-image
                style="width: 100px; height: 100px"
                :src="item.doc_data.doc_link"
                :preview-src-list="[item.doc_data.doc_link]"
              >
              </el-image>
              {{ item.doc_data.doc_name }}
            </div>

          </div>
          <div class="booking-list-item-img">
            <!-- <div
                class="booking-list-item-img-item"
                v-for="img in item.doc_data"
                :key="img.id"
              >
                <el-image
                  style="width: 100px; height: 100px"
                  :src="img.doc_link"
                  :preview-src-list="item.doc_data.map(option => option.doc_link)"
                >
                </el-image>
              </div> -->

          </div>
        </div>

        <div class="booking-division" />

      </div>
      <!-- </van-list> -->

    </div>

  </div>
</template>

<script>
import bookingService from "@/apis/booking";
import getUserInfo from "@/models/userInfo";
import moment from "moment";
import { Toast } from "vant";
import enums from "@/views/booking/mixins/enums";
import systemService from "@/apis/system/index.js";

export default {
  data() {
    return {
      dupPrompt: false,
      orderList: [],
      searchForm: {},
      currentUserInfo: {},
      showUploadPopup: false,
      showProductTypePicker: false,
      productTypeColumns: [],
      uploadForm: {
        pay_type: [],
      },
      fileList: [],
      currentOrder: {},
      pageInfo: {
        page_index: 0,
        page_size: 50,
        total: 50,
      },
      loading: false,
      finished: false,
      uploadIng: false,
    };
  },
  mixins: [enums],

  async created() {
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    this.getDingdingDic();
    this.getOrderList();
  },
  methods: {
    moment,
    onProductTypeConfirm(value) {
      this.uploadForm.product_type_name = value.text;
      this.uploadForm.product_type = value.value;
      this.showProductTypePicker = false;
    },
    payTypeChange(value) {
      console.log(value);
      this.uploadForm.pay_type = value;
    },
    onLoad() {
      this.pageInfo.page_index += 1;
      this.getOrderList();
    },
    uploadConfirm() {
      if (this.uploadIng) return;
      const { uploadForm, fileList } = this;
      let errMsg = "";
      if (!uploadForm.pay_type || uploadForm.pay_type.length === 0) {
        errMsg = "请选择支付方式";
      } else if (!uploadForm.received_amount) {
        errMsg = "请输入实付金额";
      } else if (!uploadForm.product_type) {
        errMsg = "请选择产品类型";
      } else if (!this.fileList.length) {
        errMsg = "请上传付款凭证";
      } else if (fileList.some((item) => item.status === "uploading")) {
        // 有文件在上传中等上传结束才能提交
        errMsg = "文件正在上传中，请稍后";
      }

      if (errMsg) {
        Toast(errMsg);
        return;
      }
      const params = {
        ...uploadForm,
        pay_type: uploadForm.pay_type,
        Files: fileList.map((item) => {
          return {
            file_id: item.file_id,
          };
        }),
      };
      this.uploadIng = true;
      bookingService
        .returnedMoneyEdit(params)
        .then(() => {
          Toast("上传成功");
          this.pageInfo.page_index = 1;
          this.getOrderList();
          this.showUploadPopup = false;
          this.uploadIng = false;
        })
        .catch(() => {
          this.uploadIng = false;
        });
    },
    getDingdingDic() {
      bookingService.getDingdingDic().then((res) => {
        const data = res.productType;
        data.forEach((item) => {
          item.text = item.v;
          item.value = item.k;
        });
        this.productTypeColumns = data;
      });
    },
    copy(item) {
      this.uploadForm = {};
      this.fileList = [];
      const { uploadForm } = this;
      this.currentOrder = item;
      uploadForm.id = item.id;
      delete uploadForm.pay_type;
      this.showUploadPopup = true;
    },
    onSearch(query) {
      this.pageInfo.page_index = 1;
      this.getOrderList(query);
    },
    getOrderList() {
      const { currentUserInfo } = this;
      const query = this.$route.query;
      const params = {
        type: query.type,
        check_status: query.status || undefined,
        ding_user_id: currentUserInfo.ding_user_id,
        id: query.id || undefined,
      };
      this.loading = true;
      bookingService.dingdingDetailV2(params).then((res) => {
        // pageInfo.total = res.total_record_count;
        // if (res.page_index * res.page_size >= res.total_record_count) {
        //   this.finished = true;
        // }
        this.finished = true;
        console.log(res);
        res.forEach((item) => {
          // level1、level2、level3、level4有值的拼接成字符串，-隔开
          item.level = [item.level1, item.level2, item.level3, item.level4]
            .filter(Boolean)
            .join("-");
        });
        // if (pageInfo.page_index == 1) {
        //   this.orderList = res.data;
        // } else {
        //   this.orderList.push(...res.data);
        // }
        this.orderList = res;
        this.loading = false;
      });
    },
    onFileChanged(file, fileList) {
      this.$nextTick(() => {
        file.status = "uploading";
      });
      this.fileList = fileList;

      this.systemServiceUpload(file, fileList);
    },
    systemServiceUpload(file) {
      this.$nextTick(() => {
        file.status = "uploading";
      });
      const formData = new FormData();
      formData.append("file", file.raw);
      const query = {
        file_type: "finance_returned_money",
        file_name: file.name,
        file_ext: file.name.split(".").pop(),
        file_size: file.size,
      };

      const onUploadProgress = (progressEvent) => {
        const percentage =
          (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
        file.percentage = percentage;
        this.$forceUpdate();
      };

      systemService.upload(formData, query, onUploadProgress).then((res) => {
        file.file_id = res.file_id;
        file.file_url = res.url;
        file.status = "success";
      });
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    onFileRemove(file, fileList) {
      this.fileList = fileList;
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-list-item {
  .booking-list-item-option {
    display: flex;
    justify-content: space-between;
    padding: 15px 20px;
    border-bottom: 1px solid rgba(0, 48, 87, 0.1);
    & > div:nth-child(2) {
    }
  }
  .booking-list-item-action {
    display: flex;
    span {
      margin-left: 15px;
    }
  }
}
.booking-label {
  cursor: pointer;
}
.dupPrompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  .dupPrompt-content {
    text-align: center;
    margin: 20px 0;
    font-size: 12px;
    p {
      color: #f56c6c;
      margin: 0;
    }
  }
  .el-button {
    width: 200px;
  }
}
.booking-list-item-img-item {
  display: flex;
  flex-direction: column;
}
</style>